import React from "react";

import useTranslations from "../../../hooks/useTranslations";
import { FormStepProps } from "../../../screens/MadFormScreen";

import { Container, H3 } from "../../wombat-ui";

import MadSupervisorsForm from "./MadSupervisorsForm";
import MadSchedulingForm from "./MadSchedulingForm";
import MadInformationForm from "./MadInformationForm";
import { MadFullFragment } from "../../../graphql/fragments";

const MadConfigurationForm: React.FC<
  Omit<FormStepProps, "onNext"> & { defaultValues?: MadFullFragment }
> = (props) => {
  const t = useTranslations();

  return (
    <Container className="flex flex-col flex-grow w-full space-y-6 text-primary-900">
      <H3>{t("mads.supervisionConfiguration")}</H3>
      <MadSupervisorsForm {...props} />

      <H3>{t("mads.reportsFrequencyTitle")}</H3>
      <MadSchedulingForm {...props} />

      <H3>{t("mads.madTitleSet")}</H3>
      <MadInformationForm {...props} />
    </Container>
  );
};

export default React.memo(MadConfigurationForm);
